// DOM node types
// https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType

export const elementNode = 1
export const attributeNode = 2
export const textNode = 3
export const cdataSectionNode = 4
export const entityReferenceNode = 5
export const entityNode = 6
export const processingInstructionNode = 7
export const commentNode = 8
export const documentNode = 9
export const documentTypeNode = 10
export const documentFragmentNode = 11
export const notationNode = 12



// WEBPACK FOOTER //
// ./src/node-type.js